var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('AvailabilityEdit',{on:{"input":_vm.close},model:{value:(_vm.measures),callback:function ($$v) {_vm.measures=$$v},expression:"measures"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }